import { render, staticRenderFns } from "./MerchantConfigAddEdit.vue?vue&type=template&id=407b06fe"
import script from "./MerchantConfigAddEdit.vue?vue&type=script&lang=js"
export * from "./MerchantConfigAddEdit.vue?vue&type=script&lang=js"
import style0 from "./MerchantConfigAddEdit.vue?vue&type=style&index=0&id=407b06fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../Yobo/qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports